var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');
var secureMessageAccountEstimatedBillTemplate = require('./secureMessageAccountEstimatedBillTemplate.hbs');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var EstimationDetailsModalView = require('./EstimationDetailsModalView');

/**
 * Displays estimated bill with account info.
 *
 * @class SecureMessageAccountEstimatedBillView
 * @extends Torso.View
 * @constructor
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--top-border',
  attributes: {
    'data-account-estimated-bill': 'test'
  },
  template: secureMessageAccountEstimatedBillTemplate,

  prepareFields: {
    hasUnapprovedUpdates: 'hasUnapprovedUpdates'
  },

  events: {
    'click [data-show-details-modal]': '_showEstimationDetailsModal'
  },


  behaviors: {
    appointmentSecureMessages: {
      behavior: SecureMessageDataBehavior,
      alwaysFetch: true,
      renderOnFetch: true,
      updateEvents: [ 'view.model:change:accountNumber' ],
      ids: function(cache) {
        var accountExternalId = this.view.model.get('accountNumber');
        if (_.isUndefined(accountExternalId)) {
          return [];
        }
        var criteria = {
          isPatient: true,
          appointmentCriteria: {
            externalAppointmentCriteria: {
              accountNumbers: [accountExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessages.data:appointmentDTO.externalAppointment.type'}
    },
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, '_showEstimationDetailsModal');

    this._estimationDetailsModalView = new EstimationDetailsModalView({model: this.model});
  },

  /**
   * @method hasUnapprovedUpdates
   * @return {Boolean} true if the are outstanding updates on the insurance that need to be approved, false otherwise.
   */
  hasUnapprovedUpdates: function() {
    return this.model.get('hasUnapprovedInsuranceUpdates');
  },

  /**
   * Displays the e-statement modal.
   * @method _showEstimationDetailsModal
   * @param event {jQuery.Event} the event that triggered this function call.
   * @private
   */
  _showEstimationDetailsModal: function(event) {
    event.preventDefault();
    this.showModal(this._estimationDetailsModalView);
  }
});
